import { useState, useCallback, useEffect } from 'react'
import Image from 'next/image'

import { getDownload } from '@/data/api/s3'
import type { ImageProps } from 'next/image'
import { CDN_BASE } from '@/config'
import { isPrivateFilePath, TR2Type } from '@/interfaces'
import { cn } from '@/lib/utils'

const CdnImage = ({
  src, width, height, className, ...props
}: ImageProps & { src: string }) => {
  const [ signedUrl, setSignedUrl ] = useState<string>()

  const getSignedUrl = useCallback(async () => {
    // privateなファイルはsignedUrlを取得
    if (!isPrivateFilePath(src)) {
      return
    }
    const result = await getDownload(`${src}`, TR2Type.ProjectSound)
    if ('error' in result) {
      return
    }
    setSignedUrl(result.url)
  }, [ src ])

  useEffect(() => {
    getSignedUrl()
  },[ src, getSignedUrl ])

  if (!src) {
    return (
      <div
        className={cn('h-10 w-10',　className, 'bg-tint')}
      />
    )
  }

  if (/^\/images/.test(`${src}`)) {
    return (
      <Image
        {...{
          src, width, height, className, ...props,
        }}
        alt=""
      />
    )
  }

  // privateなファイルはsignedUrlを取得
  if (isPrivateFilePath(src)) {
    return (
      <>
        {signedUrl ? (
          <Image
            src={signedUrl}
            className={cn('h-10 w-10', className)}
            width={width}
            height={height}
            alt=""
            // placeholder="blur"
          />
        ) : (
          <div
            className={cn('h-10 w-10', className, 'bg-tint')}
          />
        )}
      </>
    )
  }

  if (/^http/i.test(`${src}`)) {
    return (
      <Image
        {...{
          src, width, height, className, ...props,
        }}
        alt=""
      />
    )
  }

  return (
    <Image
      {...{
        src: `${CDN_BASE}/${src}`,
        width,
        height,
        className,
        ...props,
      }}
      // loader={loader}
      alt=""
      placeholder="blur"
      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8dff/fwAJRgPHMSJ9dAAAAABJRU5ErkJggg=="
    />
  )
}

export default CdnImage
